'use client';

var LOGIN_POPUP = 'LOGIN_POPUP';
var showLogin = function (params) {
    var langCode = params.langCode, _a = params.isApply, isApply = _a === void 0 ? false : _a, onLoggedIn = params.onLoggedIn;
    var loginPopupDetail = {
        langCode: langCode,
        trackingProperties: {
            pageName: 'job_detail'
        },
        onLoggedIn: function () {
            onLoggedIn && onLoggedIn();
        }
    };
    if (isApply) {
        loginPopupDetail.isApply = true;
    }
    var loginEvent = new CustomEvent(LOGIN_POPUP, {
        detail: loginPopupDetail
    });
    window.dispatchEvent(loginEvent);
};

export { showLogin };
//# sourceMappingURL=showLogin.js.map
